import { useFlexibleColumns } from 'hooks/use-flexible-columns';
import React from 'react';
import { DndProvider } from 'react-dnd';
import { HTML5Backend } from 'react-dnd-html5-backend';

import UniskaiPivotItem from './uniskai-pivot-item';

export interface UniskaiPivotContentProps {}

export default function UniskaiPivotContent() {
  const { columns } = useFlexibleColumns();

  return (
    <DndProvider backend={HTML5Backend}>
      {columns.map((item: any, index) => (
        <UniskaiPivotItem
          key={`${item.accessorKey}-${item.header}`}
          index={index}
          item={item}
        />
      ))}
    </DndProvider>
  );
}
